export default {"src":"/_next/static/media/0xe57ebd2d67b462e9926e04a8e33f01cd0d64346d.684ff353.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};